import React, { Component } from 'react';
import { Redirect, Switch, Link, BrowserRouter, Route } from 'react-router-dom'


// компоненты
import Header from './component/Header';
import Footer from './component/Footer';
import Auth from './component/Auth';
import Libr from './component/Libr';
import LibrStat from './component/LibrStat';
import Econ from './component/Econ';
import Prep from './component/Prep';

import EconForm1 from './component/EconForm1';
import EconForm2 from './component/EconForm2';
import EconForm3 from './component/EconForm3';
import EconForm4 from './component/EconForm4';
import EconForm5 from './component/EconForm5';

import Test from './component/Test';


import Stat from './component/Stat';
import routes from './routes';
import history from './history';


const RouteWithSubRoutes = (route) => (
  <Route path={route.path} render={props => (
    // pass the sub-routes down to keep nesting
    <route.component {...props} routes={route.routes}/>
  )}/>
)

class App extends Component {

    constructor(props) {
    super(props);

    this.getSessionData = this.getSessionData.bind(this);
    this.setSessionData = this.setSessionData.bind(this);
    this.getRoleByLogin = this.getRoleByLogin.bind(this);
    this.clearSession = this.clearSession.bind(this);
    this.setSession = this.setSession.bind(this);
    this.checkIsLoggedIn = this.checkIsLoggedIn.bind(this);
    this.logIn = this.logIn.bind(this);
    this.logOut = this.logOut.bind(this);
    this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
    this.getNameRole = this.getNameRole.bind(this);
    this.setDefaultPps = this.setDefaultPps.bind(this);

    this.state = {
        date: new Date(),
        //сохраняем в состояние данные из сессионного хранилища
        login: this.getSessionData('login'),
        password: this.getSessionData('password'),
        role: this.getSessionData('role'),
        isLoggedIn: this.checkIsLoggedIn(),
        default: {
            fio: '',
            title: '',
            type: 'Статья',
            subtype_1: 0,
            subtype_2: 0,
            subtype_3: 0,
            countAuthor: 0,
            countPageMin: 0,
            countPageMax: 0
        }
    };

    }

    componentDidMount() {
        //console.log('Mount: App');
        //надо ли показывать окно авторизации
        /*
        let login = this.state.login;
        let password = this.state.password;
        let role = this.state.role;

        if( login && password && role ){
           console.log('ты уже авторизован');
        } else {
            console.log('в сессии пусто');
        }
        */
        if( this.checkIsLoggedIn() ){
            let url = "/#/"+this.state.role;
            window.location.href = url;
        }
    }

    //проверка, залогинен ли пользователь
    checkIsLoggedIn(){
        let role = this.getSessionData('role');
        if(role == null){
            return false
        } else {
            return true
        }
    }

    //получение данных из сессии по ключу
    getSessionData(key){
        let value = sessionStorage.getItem(key);
        return value;
    }

    //запись данных в сессию
    setSessionData(key, value){
        console.log(key, value);
        sessionStorage.setItem(key, value);
    }

    //записываем в состояние роль
    setRole(role){
        this.setState({
            role: role
        })
    }

    //узнаем роль по сохраненным в сессии логину и паролю !!убрать
    getRoleByLogin(){
        let login = sessionStorage.getItem('login');
        let password = sessionStorage.getItem('password');
        if( this.checkLogin(login,password) ){
           console.log('верно');
        }else{
            console.log('ошибка');
        }
    }

    //очищаем данные сессии
    clearSession(){
        sessionStorage.removeItem('login');
        sessionStorage.removeItem('password');
        sessionStorage.removeItem('role');

        let login = this.getSessionData('login');
        let password = this.getSessionData('password');
        let role = this.getSessionData('role');
        console.log('Теперь в сессии: '+login+'-'+password+'-'+role);
    }

    //запись сессии
    setSession(){
        let login = this.state.login;
        let password = this.state.password;
        let role = this.state.role;
        this.setSessionData('login', login);
        this.setSessionData('password', password);
        this.setSessionData('role', role);
    }

    //обновление элемента
    forceUpdateHandler(){
        this.forceUpdate();
    };

    //вход
    logIn(login, password, role){
        //console.log('Пришло: '+login+'-'+password+'-'+role);
        this.setState({
            login: login,
            password: password,
            role: role,
            isLoggedIn: true
        })
        this.setSessionData('login', login);
        this.setSessionData('password', password);
        this.setSessionData('role', role);
        //history.push('/'+role);
        window.location.href = "/";
        //window.location.reload();
    }

    //выход
    logOut(){
        this.setState({
            login: null,
            password: null,
            role: null,
            isLoggedIn: false
        });
        this.clearSession();
    }

    //получение человеческого названия роли
    getNameRole(){
        let role = this.state.role;
        let roles = ['libr','econ','prep'];
        let names = ['Библиотекарь', 'Экономист','Преподаватель'];
        for(let i = 0; i < roles.length; i++){
            if(roles[i] == role){
                return names[i]
            } else {
                return roles[i]
            }
        }
    }

    setDefaultPps(pps){
        this.setState({
            default: {
                id_pps: pps[0],
                fio: pps[1],
                title: pps[2],
                type: pps[3],
                subtype_1: pps[4],
                subtype_2: pps[5],
                subtype_3: pps[6],
                countAuthor: pps[7],
                countPageMin: pps[8],
                countPageMax: pps[9]
            }
        });
    }

    componentWillMount(){

    }

    render() {
        //кнопка выхода
        const LogOutButton = () => (
            this.state.isLoggedIn ? (
            <div>
                {/*<div>Вы вошли как: {this.getNameRole()}</div>*/}
                <div className='logout-button' onClick={this.logOut}>Выйти</div>
            </div>
            ) : ('')
        )

    return (
      <div className="app">
        <Header />
        <LogOutButton />

        <Switch>
            /*      /        */
            <Route exact path="/" render={() => (
              this.state.isLoggedIn ? (
                <Redirect to={'/'+this.state.role}/>
              ) : (
                <Redirect to={'/auth'}/>
              )
            )}/>

            /*      /auth        */
            <Route exact path="/auth" render={() => <Auth logIn={this.logIn} />}/>

            /*      /libr        */
            <Route exact path="/libr" render={() => (
              this.state.role == 'libr' ? (
                <Libr role={this.state.role} defaultPps={this.state.default}/>
              ) : (
                <Redirect to={'/'}/>
              )
            )}/>

            /*      /librStat        */
            <Route exact path="/librstat" render={() => (
              this.state.role == 'libr' ? (
                <LibrStat role={this.state.role} editPps={this.setDefaultPps}/>
              ) : (
                <Redirect to={'/'}/>
              )
            )}/>

            /*      /econ        */
            <Route exact path="/econ" render={() => (
              this.state.role == 'econ' ? (
                <Econ role={this.state.role}/>
              ) : (
                <Redirect to={'/'}/>
              )
            )}/>

            /*      /econForm1        */
            <Route path="/econForm1" render={() => (
              this.state.role == 'econ' ? (
                <div className='econ-wrap'>
                  <Econ role={this.state.role}/>
                  <EconForm1/>
                  </div>
              ) : (
                <Redirect to={'/'}/>
              )
            )}/>

            /*      /econForm2      */
            <Route path="/econForm2" render={() => (
              this.state.role == 'econ' ? (
                <div className='econ-wrap'>
                  <Econ role={this.state.role}/>
                  <EconForm2/>
                  </div>
              ) : (
                <Redirect to={'/'}/>
              )
            )}/>

            /*      /econForm3     */
            <Route path="/econForm3" render={() => (
              this.state.role == 'econ' ? (
                <div className='econ-wrap'>
                  <Econ role={this.state.role}/>
                  <EconForm3/>
                  </div>
              ) : (
                <Redirect to={'/'}/>
              )
            )}/>

            /*      /econForm4 (цапок)     */
            <Route path="/econForm4" render={() => (
              this.state.role == 'econ' ? (
                <div className='econ-wrap'>
                  <Econ role={this.state.role}/>
                  <EconForm4/>
                  </div>
              ) : (
                <Redirect to={'/'}/>
              )
            )}/>

            /*      /econForm5 (цапок)    */
            <Route path="/econForm5" render={() => (
              this.state.role == 'econ' ? (
                <div className='econ-wrap'>
                  <Econ role={this.state.role}/>
                  <EconForm5/>
                  </div>
              ) : (
                <Redirect to={'/'}/>
              )
            )}/>



            /*      /prep        */
            <Route exact path="/prep" render={() => (
              this.state.role == 'prep' ? (
                <Prep role={this.state.role}/>
              ) : (
                <Redirect to={'/'}/>
              )
            )}/>

            /*      /stat        */
            <Route exact path="/stat" render={() => (
              this.state.role == 'stat' ? (
                <Stat role={this.state.role}/>
              ) : (
                <Redirect to={'/'}/>
              )
            )}/>

            /*      /test        */
            <Route exact path="/test" render={() => (
              this.state.role == 'test' ? (
                <Test role={this.state.role} defaultPps={this.state.default}/>
              ) : (
                <Redirect to={'/'}/>
              )
            )}/>
          //<Route path='/auth' component={Auth}/>
          //<Route path='/libr' component={Libr}/>
          //<Route path='/stat' component={Stat}/>

          //<Route path='/libr' render={() => <Libr isLoggedIn={this.state.isLoggedIn} role={this.state.role}/>}/>
          //<Route path='/stat' render={() => <Stat isLoggedIn={this.state.isLoggedIn} role={this.state.role}/>}/>
          //<Route path='/auth' render={() => <Auth role='{this.state.role}' />}/>
        </Switch>

        <Footer />
      </div>
    );
    }

}

export default App;



// WEBPACK FOOTER //
// ./src/App.js